<template>
  <div class="max-w-7xl mx-auto ">
    <div class="bg-white overflow-hidden shadow-sm pt-3 sm:rounded-xs border my-3">
      <div id="calendar-demo">
        <div class="calendar-container">
          <DxCalendar v-model:value="currentValue" zoom-level="month" :first-day-of-week="firstDay"
            :cell-template="cellTemplate">
            <template #custom="{ data: cell }">
              <span :class="getCellCssClass(cell)" :title="getTooltip(cell)">
                {{ cell.text }}
              </span>
            </template>
          </DxCalendar>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import JetButton from '@/Jetstream/Button.vue'
import { DxCalendar, DxDateBox } from 'devextreme-vue';
import { ref, computed } from 'vue';
import { DxTooltip } from 'devextreme-vue/tooltip';

export default {
  props: {
  },
  components: {
    JetButton,
    DxCalendar,
    DxDateBox,
    DxTooltip,
    computed,
    ref,
  },

  data() {

    return {
      cssClass: '',
      currentValue: ref(new Date()),
      cellTemplate: ref('custom'),
      firstDay: 1,
      holidays: [
        { date: [1, 0], name: 'New Year' },
        { date: [15, 7], name: 'Independence Day' },
        { date: [2, 9], name: 'Mahatma Gandhi Jayanti' },
        { date: [11, 9], name: 'Mahastmi/Navami' },
        { date: [12, 9], name: 'Dassehra' },
        { date: [1, 10], name: 'Diwali' },
      ],
    };
  },

  methods: {
    isWeekend(date) {
      const day = date.getDay();
      return day === 0;
    },

    getCellCssClass({ date, view }) {
      let cssClass = '';

      if (view === 'month') {
        if (!date) {
          cssClass = 'week-number';
        } else {
          if (this.isWeekend(date)) { cssClass = 'weekend'; }

          this.holidays.forEach((item) => {
            if (date.getDate() === item.date[0] && date.getMonth() === item.date[1]) {
              cssClass = 'holiday';
            }
          });
        }
      }
        return cssClass;
      },
      getTooltip(cell) {
      if (this.isHoliday(cell.date)) {
        const holiday = this.holidays.find(
          (h) => cell.date.getDate() === h.date[0] && cell.date.getMonth() === h.date[1]
        );
        return holiday ? holiday.name : '';
      }
      return '';
    },
    isHoliday(date) {
      return this.holidays.some((h) => date.getDate() === h.date[0] && date.getMonth() === h.date[1]);
    },

    },

  }

</script >

<style >
#calendar-demo {
  display: flex;
}
.dx-calendar {
  width: 292px;
  min-width: 340px;
}

.calendar-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
}

.dx-calendar-cell:not(.dx-calendar-other-month) .weekend,
.dx-calendar-cell:not(.dx-calendar-other-month) .holiday {
  text-shadow: none;
  font-weight: bold;
}

.dx-calendar-cell:not(.dx-calendar-other-month) .weekend {
  color: #3030ff;
}

.dx-state-disabled.dx-calendar .dx-calendar-cell:not(.dx-calendar-other-month) .weekend {
  color: #8080ff;
}

.dx-calendar-cell:not(.dx-calendar-other-month) .holiday {
  color: #ff3030;
}

.dx-state-disabled.dx-calendar .dx-calendar-cell:not(.dx-calendar-other-month) .holiday {
  color: #ff8080;
}

.dx-calendar-week-number-cell .week-number {
  font-style: italic;
}

.caption {
  font-weight: 500;
  font-size: 18px;
}

.options {
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
}

.option {
  margin-top: 10px;
}
</style>